import { render, staticRenderFns } from "./shopLogo_menu.vue?vue&type=template&id=9c4fb0fc"
import script from "./shopLogo_menu.vue?vue&type=script&lang=js"
export * from "./shopLogo_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports